import Vue from 'vue'
import moment from 'moment';
Vue.filter('stringDateAll', (val) => {   
  return moment(val).format('LLL');
})

Vue.filter('stringDateYear', (val) => {   
  return moment(val).locale('es').format('LL');
})



// WEBPACK FOOTER //
// ./src/vue/filters.js